<div class="container-fluid">
  <div class="row">

    <div class="col-12 text-center py-3 bg-secondary">
      Cleversec© 2025 - Todos los derechos reservados.
    </div>
    
  </div>
</div>